import { Main, Container, H, P, Grid, Card } from 'components';

import { simpleStates } from 'tasks';

const SimpleStatesPage = () => {
  const { tasks } = simpleStates;

  return (
    <Main>
      <Container>
        <H level={1}>examples of simple states</H>
        <P>Counter hook case.</P>
      </Container>
      <Container>
        <Grid>
          {tasks.map(({ title, task }, i) => (
            <Card key={i} title={title}>
              {task}
            </Card>
          ))}
        </Grid>
      </Container>
    </Main>
  );
};

export { SimpleStatesPage };
